import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { getExtras } from 'utils/formUtils';
import { isReopenKioskPage } from 'modules/router/selectors';
import { getSelectedSelfService } from 'modules/selfServices/selectors';

import { RootState } from '../../App/rootReducer';

const getState = (state: RootState) => state.basket;

export const isModalOpen = createDraftSafeSelector(getState, ({ modalOpen }) => modalOpen);

export const isOverviewModalOpen = createDraftSafeSelector(getState, ({ overviewModalOpen }) => overviewModalOpen);

export const shouldDisplayBasketModal = createDraftSafeSelector(
  isModalOpen,
  isReopenKioskPage,
  getSelectedSelfService,
  (isOpen, isReopenFlow, selfService) => !isReopenFlow
    && (isOpen || getExtras(selfService)?.length > 0 || selfService?.repairOrder?.length > 0 || selfService?.proactiveChecklists?.length > 0),
);
